(function () {
  const STORAGE_KEY = 'stahkCompareItems';
  const MAX_ITEMS = 5;

  const state = {
    activePair: [0, 1],
    selectedFrames: {}
  };

  const frameMap = {
    canvas: 'canvasImage',
    black: 'blackFrameImage',
    gold: 'goldFrameImage'
  };

  const roomsIconMap = {
    'living room': '🛋',
    bedroom: '🛏',
    'dining room': '🍽',
    office: '💼',
    hallway: '🚪',
    entryway: '🚪',
    lounge: '🛋',
    study: '💼'
  };

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    renderAll();
  }

  function getFrame(index) {
    return state.selectedFrames[index] || 'canvas';
  }

  function getImage(item, index) {
    return item[frameMap[getFrame(index)]] || item.canvasImage;
  }

  function formatRooms(rooms) {
    if (!rooms) return '🛋 Living Room';

    return rooms
      .split(/,|•|\n/)
      .map(room => room.trim())
      .filter(Boolean)
      .map(room => {
        const icon = roomsIconMap[room.toLowerCase()] || '•';
        return `${icon} ${room}`;
      })
      .join('<br>');
  }

  function addProduct(product) {
    let items = getItems().filter(item => item.handle !== product.handle);

    if (items.length >= MAX_ITEMS) {
      items.shift();
    }

    items.push(product);
    saveItems(items);
  }

  function removeProduct(index) {
    const items = getItems();
    items.splice(index, 1);

    state.activePair = state.activePair
      .filter(i => i !== index)
      .map(i => (i > index ? i - 1 : i));

    while (state.activePair.length < 2 && state.activePair.length < items.length) {
      const next = items.findIndex((_, i) => !state.activePair.includes(i));
      if (next !== -1) state.activePair.push(next);
      else break;
    }

    saveItems(items);
  }

  function clearCompare() {
    localStorage.removeItem(STORAGE_KEY);
    state.activePair = [0, 1];
    state.selectedFrames = {};
    renderAll();
  }

  function renderTray() {
    const tray = document.getElementById('stahkCompareBar');
    if (!tray) return;

    const items = getItems();

    if (!items.length) {
      tray.hidden = true;
      tray.innerHTML = '';
      return;
    }

    tray.hidden = false;

    const dots = Array.from({ length: MAX_ITEMS }, (_, i) => {
      return `<span class="${i < items.length ? 'active' : ''}"></span>`;
    }).join('');

tray.innerHTML = `
  <div class="stahk-compare-bar-inner">

    <div class="stahk-compare-progress">
      ${dots}
    </div>

    <div class="stahk-compare-bar-items">
          ${items.slice(0, 3).map((item, index) => `
            <div class="stahk-compare-bar-item">
              <img src="${getImage(item, index)}" alt="${item.title}">
            </div>
          `).join('')}

          ${items.length > 3 ? `<span class="stahk-compare-extra">+${items.length - 3}</span>` : ''}
        </div>

        <div class="stahk-compare-count">
  ${items.length} out of ${MAX_ITEMS} selected
</div>

        <div class="stahk-compare-bar-actions">
          ${items.length >= 2
            ? `<a href="/pages/compare-artworks" class="stahk-compare-bar-link">Compare</a>`
            : `<span class="stahk-compare-bar-note">Choose another design</span>`
          }
          <button type="button" class="stahk-compare-clear">Clear</button>
        </div>
      </div>
    `;

    tray.querySelector('.stahk-compare-clear')?.addEventListener('click', clearCompare);
  }

  function renderComparePage() {
    const grid = document.getElementById('stahkCompareGrid');
    const slider = document.getElementById('stahkCompareSlider');

    if (!grid) return;

    const items = getItems();

    if (!items.length) {
      if (slider) slider.innerHTML = '';
      grid.innerHTML = `
        <div class="stahk-compare-empty">
          <h2>No artworks selected</h2>
          <p>Browse the collection and add designs to your shortlist.</p>
          <a href="/collections/all">Browse Artworks</a>
        </div>
      `;
      return;
    }

    if (items.length >= 2 && slider) {
      renderSlider(items);
    } else if (slider) {
      slider.innerHTML = `
        <div class="stahk-slider-empty">
          <p>Add one more artwork to unlock comparison.</p>
        </div>
      `;
    }

    grid.innerHTML = `
      <div class="stahk-shortlist-heading">
        <p>Your Design Shortlist</p>
        <span>Select any two artworks to compare.</span>
      </div>

      ${items.map((item, index) => {
        const isActive = state.activePair.includes(index);
        const frame = getFrame(index);

        return `
          <article class="stahk-compare-card ${isActive ? 'is-active' : ''}" data-index="${index}">
            <button class="stahk-compare-remove" type="button" data-remove="${index}">×</button>

            <div class="stahk-compare-image-wrap">
              <img src="${getImage(item, index)}" alt="${item.title}">
            </div>

            <div class="stahk-card-frame-switcher">
              <button type="button" class="${frame === 'canvas' ? 'active' : ''}" data-card-frame="${index}" data-frame="canvas">Gallery</button>
              <button type="button" class="${frame === 'black' ? 'active' : ''}" data-card-frame="${index}" data-frame="black">Black</button>
              <button type="button" class="${frame === 'gold' ? 'active' : ''}" data-card-frame="${index}" data-frame="gold">Gold</button>
            </div>

            <div class="stahk-compare-content">
              <div class="stahk-compare-block">
                <span class="stahk-compare-label">Available Sizes</span>
                <p>${item.sizes}</p>
              </div>

              <div class="stahk-compare-block">
                <span class="stahk-compare-label">Best For</span>
                <p>${formatRooms(item.rooms)}</p>
              </div>

              <a href="${item.url}" class="stahk-compare-view">Buy Artwork</a>
            </div>
          </article>
        `;
      }).join('')}
    `;

    grid.querySelectorAll('.stahk-compare-card').forEach(card => {
      card.addEventListener('click', event => {
        if (event.target.closest('a') || event.target.closest('button')) return;
        selectCard(Number(card.dataset.index));
      });
    });

    grid.querySelectorAll('[data-card-frame]').forEach(button => {
      button.addEventListener('click', event => {
        event.stopPropagation();

        const index = button.dataset.cardFrame;
        state.selectedFrames[index] = button.dataset.frame;

        renderComparePage();
        renderTray();
      });
    });

    grid.querySelectorAll('[data-remove]').forEach(button => {
      button.addEventListener('click', event => {
        event.stopPropagation();
        removeProduct(Number(button.dataset.remove));
      });
    });
  }

  function renderSlider(items) {
    const slider = document.getElementById('stahkCompareSlider');
    if (!slider || items.length < 2) return;

    state.activePair = state.activePair
      .filter(index => index < items.length)
      .slice(0, 2);

    while (state.activePair.length < 2) {
      const next = items.findIndex((_, i) => !state.activePair.includes(i));
      if (next !== -1) state.activePair.push(next);
      else break;
    }

    const leftIndex = state.activePair[0];
    const rightIndex = state.activePair[1];

    const left = items[leftIndex];
    const right = items[rightIndex];

    slider.innerHTML = `
      <div class="stahk-slider-header">
        <div>
          <p>Compare</p>
          <h2>Drag to compare selected artworks</h2>
        </div>
      </div>

      <div class="stahk-drag-slider">
        <img class="stahk-slider-img stahk-slider-img-left" src="${getImage(left, leftIndex)}" alt="${left.title}">

        <div class="stahk-slider-right-layer" style="clip-path: inset(0 0 0 50%);">
          <img class="stahk-slider-img stahk-slider-img-right" src="${getImage(right, rightIndex)}" alt="${right.title}">
        </div>

        <div class="stahk-slider-line" style="left: 50%;">
          <span></span>
        </div>

        <input type="range" min="0" max="100" value="50" class="stahk-slider-range" aria-label="Drag to compare artworks">
      </div>
    `;

    const range = slider.querySelector('.stahk-slider-range');
    const rightLayer = slider.querySelector('.stahk-slider-right-layer');
    const line = slider.querySelector('.stahk-slider-line');

    range.addEventListener('input', () => {
      rightLayer.style.clipPath = `inset(0 0 0 ${range.value}%)`;
      line.style.left = `${range.value}%`;
    });
  }

  function selectCard(index) {
    if (state.activePair.includes(index)) return;

    state.activePair.shift();
    state.activePair.push(index);

    renderComparePage();
  }

  function renderAll() {
    renderTray();
    renderComparePage();
  }

  function initButtons() {
    document.querySelectorAll('[data-stahk-compare-product]').forEach(button => {
      button.addEventListener('click', () => {
        try {
          const product = JSON.parse(button.dataset.stahkCompareProduct);
          addProduct(product);
        } catch (error) {
          console.error('STAHK compare product data error:', error);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    renderAll();
  });
})();